/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class LegendConfigurationModel {
        public mapConfiguration:Wars.Domain.Model.Gis.MapConfiguration;
        public currentLegend: Wars.Domain.Model.Gis.LegendConfiguration;
        public addLayer:Wars.Domain.Model.Gis.Layer;

       constructor(private mapConfigurationService: services.MapConfigurationService,
           private legendConfigurationService:services.LegendConfigurationService,
           private deleteService: services.DeleteService,
           private mapConfigurationId:string) {

           this.mapConfigurationService.getMapConfiguration(mapConfigurationId).then(m => {
               this.mapConfiguration = m;
           });
       }

       public addLegend() {
           let newLegend = this.legendConfigurationService.createLegendConfiguration();

           newLegend.hideSingleBase = false;
           newLegend.displayCornerLocation = Wars.Domain.Model.Codes.DisplayCornerLocation.TopRight;
           newLegend.sortLayers = true;
           newLegend.name = "New Legend";
           newLegend.isDefault = this.mapConfiguration.legendConfigurations.length === 0;

           this.mapConfiguration.legendConfigurations.push(newLegend);
           this.currentLegend = newLegend;

           this.save();
       }

        public addLegendLayer() {
            let newLegendLayer = this.legendConfigurationService.createLegendLayer();

            newLegendLayer.layer = this.addLayer;
            newLegendLayer.name = this.addLayer.name;

            this.currentLegend.legendLayers.push(newLegendLayer);

            this.save();
        }

        public defaultChanged() {
            this.mapConfiguration.legendConfigurations.forEach(l => {
                if (l.id !== this.currentLegend.id) {
                    l.isDefault = false;
                }
            });

            this.save();
        }

        public delete() {
            this.deleteService.deleteWithModalConfirmIfNecessary("LegendConfiguration",this.currentLegend.id,"Legend Configuration",() => {
                this.mapConfiguration.legendConfigurations.remove(this.currentLegend);
                this.currentLegend = null;
            });

        }

        public deleteLegendLayer(legendLayer:Wars.Domain.Model.Gis.LegendLayer) {
            legendLayer.entityAspect.setDeleted();
            this.save();
        }

       public save() {
           this.mapConfigurationService.saveAllChanges();
       }
   } 
}